import type React from 'react';
import { useParams } from 'react-router';
import { MainContent } from '../../../components/MainContent';
import { LazySheetEditor } from '../../../components/sheet-editor/LazySheetEditor.tsx';
import { useLabSheets } from '../../../hooks/useLabSheets.ts';

export const Sheets: React.FC = () => {
  const { id: labId } = useParams<{ id: string }>();
  const { autoSave, loading, sheetData, labParameters } = useLabSheets(labId ?? '');

  return (
    <MainContent size="medium">
      <LazySheetEditor
        loading={loading}
        sheets={sheetData}
        onChange={autoSave}
        showLab={false}
        flipParamNames={false}
        parameters={labParameters}
      />
    </MainContent>
  );
};
